import React, { lazy } from 'react';
import { Section } from './Shared';
import { Scale, Check } from 'lucide-react';
export function About() {
  const achievements = ['Recuperar semanas cotizadas que llevaban décadas perdidas en el sistema.', 'Descubrir que estaban en el régimen equivocado y corregirlo a tiempo.', 'Calcular su brecha pensional real y diseñar un plan para cerrarla.', 'Entender su situación pensional por primera vez en su vida laboral.'];
  return <Section bg="white" data-id="element-15">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-16">
        <div data-id="element-17">
          <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center mb-6" data-id="element-18">
            <Scale className="w-6 h-6 text-slate-900" data-id="element-19" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-20">
            Somos el equipo de analistas y juristas pensionales más accesible de
            Colombia.
          </h2>
          <div className="space-y-4 text-lg text-slate-700" data-id="element-21">
            <p data-id="element-22">
              No somos un fondo privado. No somos Colpensiones. No tenemos
              afiliados que proteger ni productos que venderte.
            </p>
            <p data-id="element-23">
              Somos un equipo independiente de analistas y abogados
              especializados en derecho pensional colombiano que trabajan para
              una sola persona:
            </p>
            <p className="text-2xl font-bold text-slate-900 pt-2" data-id="element-24">Tú.</p>
          </div>
        </div>

        <div className="space-y-6" data-id="element-25">
          <img src="https://cdn.magicpatterns.com/uploads/vWrv3SbJ3UEgyhdmCkyNhj/Imagen_3_pagina_Solucion_a_Pension.png" alt="Pareja mayor revisando juntos su diagnóstico pensional en una tablet en casa" className="w-full rounded-2xl shadow-lg object-cover" loading="lazy" data-id="element-26" />
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200" data-id="element-27">
            <p className="font-semibold text-slate-900 mb-6" data-id="element-28">
              Desde que iniciamos hemos ayudado a colombianos en todo el país a:
            </p>
            <ul className="space-y-4" data-id="element-29">
              {achievements.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-30">
                  <div className="mt-1 bg-[#25D366]/10 p-1 rounded-full flex-shrink-0" data-id="element-31">
                    <Check className="w-4 h-4 text-[#25D366]" data-id="element-32" />
                  </div>
                  <span className="text-slate-700" data-id="element-33">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}